import useAuthenticatedAxios from "./use-authenticated-axios";
import useSWR from "swr";
import { useCallback, useMemo } from "react";
import useSWRImmutable from "swr/immutable";
import useLogout from "./use-logout";

import useAuth from "./use-auth.js";

const ROOT_PATH = "account";

export default function useAccount() {
  const axios = useAuthenticatedAxios();
  const logout = useLogout();

  const { auth } = useAuth();
  const fallbackData = useMemo(() => {
    return {
      partner_codes: [],
    };
  }, []);
  const {
    data: account,
    error,
    isLoading,
    mutate,
  } = useSWR(
    ROOT_PATH ? { url: ROOT_PATH, userId: auth.userId } : null,
    ({ url }) => {
      return axios.get(url).then((res) => res.data);
    },
    { fallbackData },
  );

  const { data: filleuls } = useSWRImmutable(
    { url: `${ROOT_PATH}/filleuls`, userId: auth.userId },
    ({ url }) => {
      return axios.get(url).then((res) => res.data);
    },
  );

  async function changePassword(values) {
    return mutate(
      async () => {
        await axios.put(`change-password`, { ...values });
      },
      { revalidate: false },
    );
  }

  async function requestEmailChange(values) {
    const response = await axios.post(`${ROOT_PATH}/email-change`, values);
    return response.data;
  }

  async function verifyEmailChange(values) {
    const response = await axios.post(
      `${ROOT_PATH}/email-change/verify`,
      values,
    );
    await mutate();
    return response.data;
  }

  async function resendEmailChangeCode(token) {
    await axios.post(`${ROOT_PATH}/email-change/resend`, { token });
  }

  async function updateCompte(resource) {
    let newResource;
    await mutate(
      async () => {
        const response = await axios.put(ROOT_PATH, resource);
        newResource = response.data;
        return response.data;
      },
      { revalidate: false },
    );
    return newResource;
  }

  const subscribe = useCallback(
    async (values, preview = false) => {
      if (preview) {
        return axios.post("subscribe", values);
      }
      let newResource;
      await mutate(
        async () => {
          const response = await axios.post("subscribe", values);
          newResource = response.data;
          return response.data;
        },
        { revalidate: false },
      );
      return newResource;
    },
    [axios, mutate],
  );

  async function unsubscribe(values) {
    let newResource;
    await mutate(
      async () => {
        const response = await axios.delete("unsubscribe", {
          data: values,
        });
        newResource = response.data;
        return response.data;
      },
      { revalidate: false },
    );
    return newResource;
  }
  async function deleteAccount(values) {
    await mutate(
      async () => {
        await axios.delete("account", { data: values });
        logout();
        window.location.href = "https://www.qalimo.fr";
      },
      { revalidate: false },
    );
  }

  return {
    account,
    filleuls: filleuls || {},
    hasValidAddress:
      account.adresse && account.ville && account.cp && account.nom,
    error,
    isLoading,
    changePassword,
    requestEmailChange,
    verifyEmailChange,
    resendEmailChangeCode,
    updateCompte,
    subscribe,
    unsubscribe,
    deleteAccount,
    refresh: () => mutate(),
  };
}
